import request from '@/utils/request'

export const warehouseApi = {
  // 获取仓库列表
  list(data) {
    return request({
      url: '/inventory-management-api/warehouse/list',
      method: 'POST',
      data
    })
  },

  // 创建仓库
  create(data) {
    return request({
      url: '/inventory-management-api/warehouse/create',
      method: 'POST',
      data
    })
  },

  // 更新仓库
  update(data) {
    return request({
      url: '/inventory-management-api/warehouse/update',
      method: 'POST',
      data
    })
  },

  // 删除仓库
  delete(data) {
    return request({
      url: '/inventory-management-api/warehouse/delete',
      method: 'POST',
      data
    })
  }
}